import { useTranslation } from '@/i18n'
import { AKEERA_AVATAR_SRC, HELP_WIDGET_Z } from './constants'

/**
 * Floating circular avatar button, fixed bottom-right (logical `end-*` so
 * it mirrors to bottom-left under RTL). Opens the help panel.
 */
const HelpAgentLauncher = ({ onOpen }: { onOpen: () => void }) => {
  const { t } = useTranslation('help_agent')
  return (
    <button
      type="button"
      aria-label={t('launcher.open')}
      onClick={onOpen}
      className={`fixed bottom-6 end-6 ${HELP_WIDGET_Z} size-14 overflow-hidden rounded-full shadow-lg ring-2 ring-white transition-transform hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring dark:ring-dark-border`}
    >
      <img src={AKEERA_AVATAR_SRC} alt="" className="size-full object-cover" />
    </button>
  )
}

export default HelpAgentLauncher
